import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { IOrderInput } from "@/interfaces/order.interfaces";
import orderService from "@/services/order.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateOrderProps = UpdateByIdProps<IOrderInput>;

export type UseUpdateOrderReturn = {
  update: (props: UpdateOrderProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateOrder = (): UseUpdateOrderReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<IOrderInput>({
    operation: (formData, orderId) => orderService.update(formData, orderId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};

export default useUpdateOrder;
